import React from 'react'
import { useNavigate } from 'react-router-dom'
import S from './AuthCallback.styles'

const AuthCallback = () => {
  const navigate = useNavigate()

  setTimeout(() => {
    // Use useNavigate() instead of <Navigate /> component because timeout is needed
    // for the app to extract the Keycloak token from the URL after signing in
    navigate('/admin')
  }, 1000)

  return (
    <S.Loader>
      <h1>Signing in...</h1>
      <p>Please wait a moment...</p>
    </S.Loader>
  )
}

export default AuthCallback
